import { MetaType, CustomTheme, FirestoreTimestampType } from "../types"

import { actionCreatorGuard, reducerGuard, reducerActions } from "../reducers"

const kind = "users"

export type VideoSettings = {
  playerVolume: number
}

export type Preferences = {
  videoSettings: VideoSettings
}

// inherited type, will remove eventually
// These are FB created entries
export type User = {
  kind: typeof kind
  version: number
  firstName: string
  lastName: string
  lastPasswordChange: FirestoreTimestampType | null
  role: string
  username: string
  theme: CustomTheme
  meta: MetaType
  preferences: Preferences
}

export const reducerAction = {
  meta: actionCreatorGuard<User, MetaType>("meta", kind),
  firstName: actionCreatorGuard<User, string>("firstName", kind),
  lastName: actionCreatorGuard<User, string>("lastName", kind),
  lastPasswordChange: actionCreatorGuard<User, FirestoreTimestampType | null>(
    "lastPasswordChange",
    kind
  ),
  role: actionCreatorGuard<User, string>("role", kind),
  theme: actionCreatorGuard<User, CustomTheme>("theme", kind),
  username: actionCreatorGuard<User, string>("username", kind),
  preferences: actionCreatorGuard<User, Preferences>("preferences", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<User, "kind" | "version">]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const userAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const userReducer = reducerGuard<User>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.username)
  .case(...reducerAction.firstName)
  .case(...reducerAction.lastName)
  .case(...reducerAction.role)
  .case(...reducerAction.lastPasswordChange)
  .case(...reducerAction.theme)
  .case(...reducerAction.preferences)
  .build()
